import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useRef, useEffect, useMemo, useCallback } from 'react';
import { isComponent } from "../../../util/is-component";
import { CarouselSled, CarouselSledContainer, CarouselItem } from "./carousel-type-slide.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var preventBubblingToParent = function preventBubblingToParent(event) {
  return event.stopPropagation();
};
var triplicateForInfiniteCarousel = function triplicateForInfiniteCarousel(children) {
  return children.concat(children).concat(children);
};
export function CarouselTypeSlide(props) {
  var children = props.children,
    currentIndex = props.currentIndex,
    gap = props.gap,
    goToIndex = props.goToIndex,
    isInfinite = props.isInfinite,
    totalPages = props.totalPages;
  var sledContainerRef = useRef(null);
  var touchStartedAt = useRef(0);
  var isRewindingRef = useRef(false);
  var touchMovedByPercentage = useRef(0);
  var slides = useMemo(function () {
    return !isInfinite ? children : triplicateForInfiniteCarousel(children);
  }, [children, isInfinite]);
  var totalSlides = slides.length;
  useEffect(function () {
    if (isInfinite) {
      goToIndex(totalPages);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (isRewindingRef.current) {
      sledContainerRef.current.style.transition = 'none';
      var value = -(currentIndex / totalSlides) * 100;
      sledContainerRef.current.style.transform = "translateX(".concat(value, "%)");
      setTimeout(function () {
        sledContainerRef.current.style.transition = null;
      }, 10);
      isRewindingRef.current = false;
    } else {
      var _value = -(currentIndex / totalSlides) * 100;
      sledContainerRef.current.style.transform = "translateX(".concat(_value, "%)");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]);
  var onTouchStart = useCallback(function (event) {
    touchStartedAt.current = event.touches[0].clientX;
  }, []);
  var onTouchEnd = useCallback(function () {
    sledContainerRef.current.style.transition = null;
    if (touchMovedByPercentage.current > 0) {
      if (currentIndex < totalSlides - 1) {
        goToIndex(currentIndex + 1);
      } else {
        var nextStaticPercentage = currentIndex / totalSlides * 100;
        sledContainerRef.current.style.transform = "translateX(".concat(-nextStaticPercentage, "%)");
      }
    }
    if (touchMovedByPercentage.current < 0) {
      if (currentIndex !== 0) {
        goToIndex(currentIndex - 1);
      } else {
        var _nextStaticPercentage = currentIndex / totalSlides * 100;
        sledContainerRef.current.style.transform = "translateX(".concat(-_nextStaticPercentage, "%)");
      }
    }
  }, [currentIndex, goToIndex, totalSlides]);
  var onCarouselTransitionEnd = useCallback(function () {
    if (isInfinite) {
      if (currentIndex > totalPages * 2) {
        isRewindingRef.current = true;
        goToIndex(currentIndex - totalPages);
      }
      if (currentIndex < totalPages) {
        isRewindingRef.current = true;
        goToIndex(currentIndex + totalPages);
      }
    }
  }, [currentIndex, goToIndex, isInfinite, totalPages]);
  var onTouchMove = useCallback(function (event) {
    var currentX = event.touches[0].clientX;
    var containerWidth = sledContainerRef.current.offsetWidth;
    var movedByPixels = touchStartedAt.current - currentX;
    var currentStaticPercentage = currentIndex / totalSlides * 100;
    var movedByPercentage = movedByPixels / containerWidth * 100;
    var absoluteCurrentPercentage = currentStaticPercentage + movedByPercentage;
    touchMovedByPercentage.current = movedByPercentage;
    sledContainerRef.current.style.transform = "translateX(".concat(-absoluteCurrentPercentage, "%)");
    sledContainerRef.current.style.transition = "none";
  }, [currentIndex, totalSlides]);
  return /*#__PURE__*/_jsx(CarouselSled, {
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    children: /*#__PURE__*/_jsx(CarouselSledContainer, {
      gap: gap,
      ref: sledContainerRef,
      totalPages: slides.length,
      onTransitionEnd: onCarouselTransitionEnd,
      children: slides.map(function (slide, index) {
        var pageProps = isComponent(slide) ? _objectSpread(_objectSpread({}, slide.props), {}, {
          index: index,
          isCurrent: currentIndex % totalPages === index % totalPages
        }) : null;
        return /*#__PURE__*/_jsx(CarouselItem, {
          onTransitionEnd: preventBubblingToParent,
          children: /*#__PURE__*/React.cloneElement(slide, pageProps)
        }, "slide-".concat(index));
      })
    })
  });
}
CarouselTypeSlide.defaultProps = {
  gap: '0',
  isInfinite: false,
  touch: true,
  transitions: {}
};
CarouselTypeSlide.displayName = 'CarouselTypeSlide';